<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header
      [separator]="false"
      [header]="data.title"
      [subheader]="data.p1"
      [imageUrl]="data.avatar_url"
    />
  </ng-container>

  <ng-container body>
    <ng-container *mailgunIf="data.note_body">
      <email-margin [height]="28" />
      <email-infobox *mailgunIf="data.note_body" [contents]="data.note_body" [wrapperTag]="'p'" />
    </ng-container>
    <email-margin [height]="28" />
    <email-button [href]="data.button_link" [label]="data.button_text" [theme]="'primary'" />
  </ng-container>

  <ng-container footer>
    <email-text
      [contents]="data.footer_link_text"
      color="light"
      presetName="inline"
      size="small"
    />&nbsp;
    <email-link
      [label]="data.support_email"
      [href]="data.support_email"
      [prefix]="'mailto:'"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
